import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

export default function Login() {
  const [username, setUser] = useState("");
  const [password, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });

      const data = await res.json();

      if (res.ok && data.token) {
        localStorage.setItem("token", data.token);
        navigate("/");
      } else {
        setError(data.error || "Usuário ou senha inválidos");
      }
    } catch (err) {
      setError("Erro de conexão com o servidor.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-900 via-blue-900 to-gray-900 px-2">
      <form
        onSubmit={handleLogin}
        className="w-full max-w-xs bg-white/90 rounded-xl shadow-xl p-6 flex flex-col gap-4"
        autoComplete="off"
      >
        <h1 className="text-2xl font-bold text-center text-indigo-800 mb-2">Painel de Cobrança</h1>

        <input
          className="border border-indigo-200 rounded-xl px-4 py-3 text-base focus:ring-2 focus:ring-indigo-400 bg-gray-50 shadow-sm"
          placeholder="SY09 ou master"
          value={username}
          onChange={e => setUser(e.target.value)}
          autoFocus
          required
        />
        <input
          type="password"
          className="border border-indigo-200 rounded-xl px-4 py-3 text-base focus:ring-2 focus:ring-indigo-400 bg-gray-50 shadow-sm"
          placeholder="Senha"
          value={password}
          onChange={e => setPass(e.target.value)}
          required
        />

        <button
          type="submit"
          className="w-full bg-indigo-700 hover:bg-indigo-800 text-white font-bold rounded-xl py-3 text-base shadow-md transition disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>

        {error && (
          <div className="text-red-600 text-center text-sm">{error}</div>
        )}
      </form>
    </div>
  );
}
